module.exports = __webpack_public_path__ + "img/identity_1.66b44224.jpg";